import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import {Box, Checkbox, Divider as MuiDivider, FormControlLabel, Typography} from "@material-ui/core";
import styled from "styled-components/macro";
import {spacing} from "@material-ui/system";
import {AccessibilityUnit} from "../../../../../models/AccessibilityUnits";

const Divider = styled(MuiDivider)(spacing);

type PropsType = {
  units: AccessibilityUnit[];
  compositeUnits: any[];
  existingUnit: AccessibilityUnit | null
  handleCompositeUnits: (newCompositeUnits: any[]) => void;
};

const CompositeUnits: FC<PropsType> = ({
  units,
  compositeUnits,
  existingUnit,
  handleCompositeUnits,
}) => {

  const handleChange = (changeUnit: any) => {
    handleCompositeUnits(compositeUnits.map((u) => {
      if (changeUnit.key === u.key) {
        return {...u, selected: !changeUnit.selected}
      }
      return u
    }))
  }

  const isExistingCompositeUnit = (
    existingUnit: AccessibilityUnit | null,
    units: AccessibilityUnit[],
    key: string,
  ): boolean => {
    if (existingUnit) {
      const filteredRelatedUnits = units.filter((i) => {
        if (i.related_to) {
          return i.related_to.find((id) => id === existingUnit.id)
        }
        return false
      })
      if (filteredRelatedUnits.length > 0) {
        return !!filteredRelatedUnits.find((i) => i.type === key)
      }
    }
    return false
  }

  const { t } = useTranslation();
  return (
    <Box
      border="1px solid rgba(255, 255, 255, 0.2)"
      p={2}
      my={4}
      borderRadius="6px"
    >
      <Box display="flex">
        <Typography variant="h6">{t("unitForm_title")}</Typography>
      </Box>
      <Divider my={4} />
      <Box>
        {compositeUnits.map((i, index) => (
          <FormControlLabel
            key={index}
            control={
              <Checkbox
                checked={i.selected || isExistingCompositeUnit(existingUnit, units, i.key)}
                disabled={i.is_mandatory || existingUnit}
                onChange={() => handleChange(i)}
              />
            }
            label={i.title}
          />
        ))}
      </Box>
    </Box>
  );
}

export default CompositeUnits